import React from 'react';

const BankSvg = (props) => (
    <svg id="bank_svg__eds-icon-bank" viewBox="0 0 16 16.53" {...props}>
        <defs>
            <style>{'.bank_svg__bank-1{fill:#231f20}'}</style>
        </defs>
        <path
            className="bank_svg__bank-1"
            d="M0 4.4L8 0l8 4.4v1.1H0V4.4zM1 6.53h14v1H1zM0 15.03h16v1.5H0z"
        />
        <path className="bank_svg__bank-1" d="M1 14.03h14v2.5H1z" />
        <path
            className="bank_svg__bank-1"
            d="M3 6.53h2v10H3zM7 6.53h2v10H7zM11 6.53h2v10h-2z"
        />
    </svg>
);

BankSvg.displayName = 'BankSvg';
export default BankSvg;
